<template>
  <div v-if="warningZone">Are you still with us?</div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { TimeAutoLogout } from "../models/requests/user.interface";

@Component
export default class AutoLogout extends Vue {
  @Prop({ type: Object as () => TimeAutoLogout, default: null, required: true }) time!: TimeAutoLogout;

  warningTimer: any;
  logoutTimer: any;
  warningZone = false;
  warningModal: any;
  events = ["click", "scroll", "keypress", "load"];

  setTimers(): void {
    this.warningTimer = setTimeout(this.warningMessage, this.time.warning * 60 * 1000);
    this.logoutTimer = setTimeout(this.logoutUser, this.time.logout * 60 * 1000);
  }

  warningMessage(): void {
    if (this.warningModal) this.warningModal.destroy();

    this.warningModal = this.$confirm({
      title: "Periodo de inactividad",
      content: "¿Quieres permanecer en la sesión? Si no confirmas en " + (this.time.logout - this.time.warning) + " minutos se cerrará tu sesión automáticamente.",
      centered: true,
      okText: "Permanecer",
      cancelText: "Salir",
      onOk: () => {
        this.warningModal.destroy();
        this.resetTimer();
      },
      onCancel: () => {
        this.$emit("changed");
        this.warningModal.destroy();
        this.$destroy();
      }
    });
  }

  logoutUser(): void {
    if (this.warningModal) this.warningModal.destroy();

    this.$info({
      title: "Sesión expirada",
      content: "Por seguridad después de un periodo de inactividad tu sesión se ha cerrado automaticamente.",
      centered: true,
      okText: "Aceptar"
    });
    this.$emit("changed");
    this.$destroy();
  }

  resetTimer(): void {
    clearTimeout(this.warningTimer);
    clearTimeout(this.logoutTimer);

    this.setTimers();
  }

  mounted(): void {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);

    this.setTimers();
  }

  destroyed(): void {
    this.events.forEach(function (event) {
      window.removeEventListener(event, this.resetTimer);
    }, this);

    clearTimeout(this.warningTimer);
    clearTimeout(this.logoutTimer);
  }
}
</script>

<style lang="scss">
.active-product {
  background-color: #ffff !important;
  cursor: pointer;
}
.active-product:hover {
  background: #e2fdfc !important;
}
.border-blue-500 {
  border-color: #004593 !important;
}
.border-gray-500 {
  background-color: #cccc;
  border-color: #bbbb !important;
}
.border-golden-500 {
  border-color: #ff0 !important;
}
.text-blue-500 {
  color: #004593 !important;
}
.text-golden-500 {
  color: #ff0 !important;
}
</style>
